// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1s9BN","right":"Footer_right__1Q8Qp","buttons":"Footer_buttons__NFzty"};